// extracted by mini-css-extract-plugin
module.exports = {"icon":"modal-error_icon__3Ok9r","message":"modal-error_message__ASenm"};